<template>
  <section>
    <HomeHeader />
    <HomeAbout />
    <HomeWork />
    <!-- <HomeCta /> -->
    <HomeArtist />
    <HomeContact />
    <HomeNewsletter />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Home',
  components: {...partials }
}
</script>
